// src/components/Copy.js
import React, { useEffect, useState } from 'react';
import { fetchCopySummaries, deleteCopy } from '../api/copyApi';
import {
    Container,
    Typography,
    Grid,
    CircularProgress,
    Alert,
} from '@mui/material';
import CopyCard from './CopyCard';
import ErrorBoundary from './ErrorBoundary';

const Copy = () => {
    const [copyData, setCopyData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchCopySummaries();
            setCopyData(data);
        } catch (err) {
            console.error(err);
            setError('Failed to fetch copy data');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteCopy(id);
            setCopyData((prevData) => prevData.filter((item) => item.id !== id));
        } catch (err) {
            console.error(`Failed to delete copy with ID ${id}:`, err);
            setError(`Failed to delete copy with ID ${id}`);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Container maxWidth="md" style={{ marginTop: '2rem' }}>
            <Typography variant="h4" align="center" gutterBottom>
                Copy Management
            </Typography>

            {loading && <CircularProgress style={{ display: 'block', margin: 'auto' }} />}
            {error && <Alert severity="error">{error}</Alert>}

            <Grid container spacing={3}>
                {copyData.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                        <ErrorBoundary>
                            <CopyCard
                                title={item.userName}
                                summary={item.copySummary}
                                creationDate={item.creationDate}
                                user={item.userIdentifier}
                                id={item.id}
                                handleDelete={handleDelete}
                                keywords={item.keywords}
                                knowledge={item.knowledge}
                                userPromptId={item.userPromptId}
                                onCopyListUpdate={fetchData}
                            />
                        </ErrorBoundary>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default Copy;
